import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-24 pb-16 flex items-center justify-center">
        <div className="text-center px-4">
          <div className="w-20 h-20 rounded-full bg-background-100 flex items-center justify-center mx-auto mb-6">
            <i className="ri-error-warning-line text-3xl text-foreground-400"></i>
          </div>
          <h1 className="font-heading font-bold text-4xl md:text-5xl text-foreground-950 mb-4">
            404
          </h1>
          <p className="text-foreground-600 mb-8 max-w-sm mx-auto">
            Diese Seite konnte nicht gefunden werden.
          </p>
          <a
            href="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
          >
            <i className="ri-home-line"></i>
            Zurück zur Startseite
          </a>
        </div>
      </main>
      <Footer />
    </div>
  );
}